import { ITemplateUI, ITemplateUIResponse } from "../types/templatesUI.type";
import $http from "../services/AxiosInstance";

interface Params {
  page?: number,
}

class TemplatesUIDataProviderRepository {
  private getImageFile(template: ITemplateUI): File | string | null {
    const { imagePath } = template;
    if (!imagePath) return null;
    if (typeof imagePath === 'string') return imagePath;
    const firstItem = imagePath[0];
    if (!firstItem) return null;
    return firstItem.image ?? null;
  }

  async getTemplates(params?: Params): Promise<ITemplateUIResponse> {
    try {
      let url = 'templatesUI';
      if (params) {
        url += `?page=${params.page}`;
      }

      const { data } = await $http.get(url);

      return data;
    } catch (error: any) {
      throw error;
    }
  }

  async createTemplate(template: ITemplateUI): Promise<ITemplateUIResponse> {
    const data: FormData = new FormData();
    data.append('name', template.name);
    data.append('urlDomain', template.urlDomain);
    data.append('primaryColour', template.primaryColour);
    const imageFile = this.getImageFile(template);
    if (imageFile) {
      data.append('imagePath', imageFile);
    }

    const templateUI = await $http.post(`/templatesUI`, data);

    return templateUI.data
  }

  async updateTemplate(id: number, template: ITemplateUI): Promise<ITemplateUIResponse> {
    const data: FormData = new FormData();
    data.append('name', template.name);
    data.append('urlDomain', template.urlDomain);
    data.append('primaryColour', template.primaryColour);
    const imageFile = this.getImageFile(template);
    if (imageFile) {
      data.append('imagePath', imageFile);
    }

    const templateUI = await $http.patch(`/templatesUI/${id}`, data);

    return templateUI.data
  }

  async getNameTemplate(path: string): Promise<ITemplateUIResponse> {
    const templateUI = await $http.get(`/templatesUI/name/urlDomain?urlDomain=${path}`);
    return templateUI.data?.name
  }

  async blockTemplate(id: number): Promise<ITemplateUIResponse> {
    const templateUI = await $http.delete(`/templatesUI/${id}`);
    return templateUI
  }

  async unBlockTemplate(id: number): Promise<ITemplateUIResponse> {
    const templateUI = await $http.patch(`/templatesUI/restore/${id}`);
    return templateUI
  }

}
export default TemplatesUIDataProviderRepository;
